<template>
  <v-card>
    <DialogBaseColoredTitle color="primary">
      <v-img
        :src="require('@/assets/img/Digital Identity logo.jpg')"
        class="rounded"
        contain
      />
    </DialogBaseColoredTitle>
    <v-divider></v-divider>
    <DialogBaseText v-if="loading"
      ><h1 class="pl-0 headline text-center primary--text">
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
        {{ $t('global.please.wait') }}
      </h1></DialogBaseText
    >
    <IdentityFormRegister
      v-if="!loading && !hasAccount"
      @register="handleRegister"
    />
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { getKeycloakClaim } from '@/helpers/jwt'
import IdentityFormRegister from './IdentityFormRegister.vue'
export default {
  components: {
    IdentityFormRegister
  },
  data: () => ({
    loading: true,
    hasAccount: false
  }),
  computed: {
    ...mapGetters(['locale'])
  },
  mounted() {
    // user is not authenticated ? redirect to login
    if (!this.$keycloak.authenticated)
      this.$router.push({
        name: 'login',
        params: { locale: this.locale }
      })
    // try to login with token
    this.handleLogin()
  },
  methods: {
    ...mapActions([
      'login',
      'loginUserKeycloak',
      'setPermissions',
      'getUserProfile',
      'getUserSettings',
      'getCreditBalance'
    ]),
    async handleLogin() {
      this.loading = true
      this.loginUserKeycloak({
        token: this.$keycloak.token,
        username: getKeycloakClaim(this.$keycloak.token, 'email')
      })
        .then(async response => {
          await this.signin(response.jwt)
        })
        .catch(e => {
          if (e.response.status === 401) {
            this.hasAccount = false
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleRegister() {
      this.loading = true
      await this.$userService
        .keycloakRegister({
          token: this.$keycloak.token
        })
        .then(async () => {
          this.hasAccount = true
          await this.handleLogin()
        })
        .catch(e => {
          if (e.response.status === 401) {
            this.hasAccount = false
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    async signin(jwt) {
      await this.setPermissions(jwt)
      await this.getUserProfile()
      await this.getUserSettings()

      await this.$router.push({
        name: 'dashboard',
        params: { locale: this.locale }
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
